import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import React from 'react';
import cn from 'classnames';
import AttachmentCaptionViewer from '@wix/da-editor-tiptap/pkg/components/Viewer/presets/AttachmentCaption';
import Full from '../../../DeviationViews/Full';
import ImageAttachment from '../../../DeviationViews/Full/Image.multi_file_deviation/ImageAttachment';
import TextRenderer from '../../../TextRenderer';
import s from './FullImageSourceWithCaption.scss';
export function isAttachmentFile(deviationOrAttachment) {
    return deviationOrAttachment.hasOwnProperty('filename') && !deviationOrAttachment.hasOwnProperty('typeId');
}
// TODO: not a great soln, since it's hardcoded and only one line
export const CAPTION_HEIGHT = 22;
function getImageSourceCaption(deviationOrAttachment) {
    var _deviationOrAttachment_extended;
    return isAttachmentFile(deviationOrAttachment) ? deviationOrAttachment.caption : (_deviationOrAttachment_extended = deviationOrAttachment.extended) === null || _deviationOrAttachment_extended === void 0 ? void 0 : _deviationOrAttachment_extended.caption;
}
export const FullImageSourceWithCaption = (_param)=>{
    var { deviationOrAttachment, id, wrapperClassName, anchorClassName, captionClassName, rendererClassName, maintainHeightForCaptions, height } = _param, viewProps = _object_without_properties(_param, [
        "deviationOrAttachment",
        "id",
        "wrapperClassName",
        "anchorClassName",
        "captionClassName",
        "rendererClassName",
        "maintainHeightForCaptions",
        "height"
    ]);
    const isAttachment = isAttachmentFile(deviationOrAttachment);
    const caption = getImageSourceCaption(deviationOrAttachment);
    const hasCaption = !!(caption === null || caption === void 0 ? void 0 : caption.excerpt);
    const adjHeight = (hasCaption || maintainHeightForCaptions) && height ? height - CAPTION_HEIGHT : height;
    return /*#__PURE__*/ React.createElement("figure", {
        id: id,
        className: wrapperClassName
    }, isAttachment ? /*#__PURE__*/ React.createElement(ImageAttachment, _object_spread_props(_object_spread({
        attachment: deviationOrAttachment
    }, viewProps), {
        height: adjHeight
    })) : /*#__PURE__*/ React.createElement(Full, _object_spread_props(_object_spread({
        deviation: deviationOrAttachment
    }, viewProps), {
        height: adjHeight
    })), hasCaption && /*#__PURE__*/ React.createElement("figcaption", {
        className: cn(s['image-figcaption'], captionClassName)
    }, /*#__PURE__*/ React.createElement(TextRenderer, {
        className: cn(s['image-figcaption-renderer'], rendererClassName),
        textContent: caption,
        tipTapViewer: AttachmentCaptionViewer
    })));
};
export default FullImageSourceWithCaption;

//# sourceMappingURL=FullImageSourceWithCaption.js.map